var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.6004 7.0525 H 6.5705 L 6.57 7.0527 C 5.0707 7.0578 3.7061 7.4401 2.6889 8.0825 C 1.6674 8.7275 0.9597 9.6731 0.9597 10.7529 V 13.9668 C 0.9597 14.245 1.1968 14.4532 1.4669 14.4532 H 11.7336 C 12.0038 14.4532 12.2408 14.245 12.2408 13.9668 V 10.7529 C 12.2408 9.6731 11.5331 8.7275 10.5116 8.0825 C 9.4874 7.4357 8.1114 7.0525 6.6004 7.0525 Z M 3.2447 8.8988 C 4.0763 8.3736 5.2678 8.0254 6.6001 8.0254 H 6.6002 C 7.9325 8.0254 9.1239 8.3736 9.9556 8.8988 C 10.7905 9.426 11.2263 10.0924 11.2263 10.7529 V 13.4805 H 1.974 V 10.7529 C 1.974 10.0925 2.4097 9.426 3.2447 8.8988 L 3.2447 8.8988 Z M 6.6001 0.9463 C 4.9164 0.9463 3.5262 2.2374 3.5262 3.8431 C 3.5262 5.4488 4.9164 6.7399 6.6001 6.7399 C 8.2838 6.7399 9.6739 5.4488 9.6739 3.8431 C 9.6739 2.2374 8.2838 0.9463 6.6001 0.9463 Z M 6.6001 1.919 C 7.7515 1.919 8.6596 2.7862 8.6596 3.8431 C 8.6596 4.8999 7.7515 5.7671 6.6001 5.7671 C 5.4487 5.7671 4.5406 4.8999 4.5406 3.8431 C 4.5406 2.7862 5.4487 1.919 6.6001 1.919 Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c9a4cd76.svg";
export { ForwardRef as ReactComponent };